import React, { createContext, useContext, useState } from "react";

const PhotoContext = createContext();

export const PhotoProvider = ({ children }) => {
  const [photos, setPhotos] = useState([]); // uploaded photos
  const [usedPhotoIds, setUsedPhotoIds] = useState([]); // photos used in canvas
  const [selectedPhoto, setSelectedPhoto] = useState(null);
  const [selectedLayout, setSelectedLayout] = useState(null);
  const [photoSelectSource, setPhotoSelectSource] = useState(null);
  const [layoutCellThumbnails, setLayoutCellThumbnails] = useState({});
  // Sidebar / library selection (NO placement intent)
  const selectPhotoFromSidebar = (photo) => {
    setPhotoSelectSource("sidebar");
    setSelectedPhoto(photo);
  };

  // Explicit placement intent (user clicked to place image)
  const selectPhotoForPlacement = (photo) => {
    setPhotoSelectSource("placement");
    setSelectedPhoto(photo);
  };
const resetPhotoPlacement = () => {
  setPhotoSelectSource(null);
};


  // Add new photos
  const addPhotos = (files) => {
    const newPhotos = Array.from(files).map((file) => ({
      id: Date.now() + Math.random(),
      name: file.name,
      src: URL.createObjectURL(file),
    }));
    setPhotos((prev) => [...prev, ...newPhotos]);
  };

  // Remove photo
  const removePhoto = (id) => {
    setPhotos((prev) => prev.filter((p) => p.id !== id));
    setUsedPhotoIds((prev) => prev.filter((pid) => pid !== id));
  };

  // Mark photo as used on canvas
  const addUsedPhoto = (id) => {
    setUsedPhotoIds((prev) => [...new Set([...prev, id])]);
  };

  // Remove photo from used
  const removeUsedPhoto = (id) => {
    setUsedPhotoIds((prev) => prev.filter((pid) => pid !== id));
  };

  return (
    <PhotoContext.Provider
      value={{
        photos,
        addPhotos,
        removePhoto,
        usedPhotoIds,
        addUsedPhoto,
        removeUsedPhoto,
        selectedPhoto,
        setSelectedPhoto,
        selectedLayout,
        setSelectedLayout,
        selectPhotoFromSidebar,
        selectPhotoForPlacement,
        photoSelectSource,
        resetPhotoPlacement,
        setLayoutCellThumbnails,
        layoutCellThumbnails,
      }}
    >
      {children}
    </PhotoContext.Provider>
  );
};

export const usePhotos = () => useContext(PhotoContext);
